module.exports = __webpack_public_path__ + "img/search.bab9d6de.png";